import React from "react";
import {
  Datagrid,
  EditButton,
  List,
  Loading,
  TextField,
  useMutation,
  useRedirect,
  FilterButton,
  FilterForm,
  TopToolbar,
  TextInput,
} from "react-admin";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CustomExportButton, CustomImportButton } from "../../Signet/util";

const NetsuiteSleeveResources = "netsuite/sleeve";

const useStyles = makeStyles({
  container: {
    width: "100%",
    padding: 0,
  },
});

const SleeveFilters = [
  <TextInput source="name" label="Name" defaultValue="" />,
  <TextInput source="sku_code" label="Sku Code" defaultValue="" />,
  <TextInput source="netsuite_id" label="Netsuite ID" defaultValue="" />,
  <TextInput source="netsuite_sleeve_type" label="Netsuite Sleeve Type" defaultValue="" />,
  <TextInput source="netsuite_sleeve_group" label="Netsuite Sleeve Group" defaultValue="" />,
];

const SleeveListActions = (props) => {
  const classes = useStyles();
  return (
    <TopToolbar className={classes.container}>
      <Box
        display={"flex"}
        alignItems={"flex-end"}
        justifyContent="space-between"
        width={"100%"}
        sx={{ paddingBottom: "14px" }}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent="space-between"
        >
          <FilterForm filters={SleeveFilters} />
        </Box>
        <Box display={"flex"} justifyItems={"flex-end"} sx={{ gap: "20px" }}>
          <CustomImportButton resource={NetsuiteSleeveResources} />
          <CustomExportButton resource={NetsuiteSleeveResources} />
          <FilterButton filters={SleeveFilters} />
        </Box>
      </Box>
    </TopToolbar>
  );
};

const CustomEdit = ({ record }) => {
  const redirect = useRedirect();
  const sleeveId = record.sleeve_id || record.id;
  const [getDetails] = useMutation({
    type: "getOne",
    resource: NetsuiteSleeveResources,
    payload: { id: sleeveId },
  });

  const handleEdit = async (e) => {
    e.preventDefault();
    getDetails();
    redirect(`/${NetsuiteSleeveResources}/${sleeveId}`);
  };

  return <EditButton onClick={handleEdit} />;
};

const SleeveList = (props) => {
  const { permissions } = props;

  if (!permissions) return <Loading />;
  return (
    <List {...props} exporter={false} actions={<SleeveListActions />}>
      <Datagrid rowClick={null}>
        <TextField source="name" label="Name" sortable={false} />
        <TextField source="sku_code" sortable={false} label="Sku Code" />
        <TextField source="netsuite_id" sortable={false} label="Netsuite ID" />
        <TextField
          source="netsuite_sleeve_type"
          sortable={false}
          label="Netsuite Sleeve Type"
        />
        <TextField
          source="netsuite_sleeve_group"
          sortable={false}
          label="Netsuite Sleeve Group"
        />
        <CustomEdit />
      </Datagrid>
    </List>
  );
};

export default SleeveList;
